import { QueryClient, useQuery } from '@tanstack/react-query';

import API from '@api/API';

export const useAppSettingsQuery = () => {
  const { isFetched, data, refetch } = useQuery({
    queryKey: useAppSettingsQuery.queryKey(),
    queryFn: useAppSettingsQuery.queryFn,
    enabled: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    appSettingsAreReady: isFetched,
    appSettings: data ?? {},
    refetchTokenIsValid: refetch,
  };
};
useAppSettingsQuery.queryKey = () => ['appSettings'];
useAppSettingsQuery.queryFn = () =>
  API.get<
    Partial<{
      featureFlags: {
        isEntertainerDashboardEnabled?: boolean;
      };
      badgeReasons: string[];
      recommendationBadgeId?: string;
      entertainerMediaBadges: { _id: string; title: string; imageUrl: string }[];
      supportActions: Record<
        string,
        {
          key: string;
          label: string;
          recommendationSlug: string;
          imgUrl: string;
        }
      >;
    }>
  >(`/v1/settings`);

export const fetchAppSettings = async (queryClient: QueryClient) => {
  await queryClient.invalidateQueries({ queryKey: useAppSettingsQuery.queryKey() });

  return queryClient.fetchQuery({
    queryKey: useAppSettingsQuery.queryKey(),
    queryFn: useAppSettingsQuery.queryFn,
  });
};
